import axios from 'axios'

export const fetchNotionPage = (pageId: string, key: string) => {
  return axios
    .get(
      `https://cors-anywhere.herokuapp.com/https://api.notion.com/v1/blocks/${pageId}/children`,
      {
        headers: {
          Authorization: `Bearer ${key}`,
          'Access-Control-Allow-Origin': '*',
          'Notion-Version': '2021-05-13',
        },
      }
    )
    .then(r => {
      return r.data.results
    })
    .catch(error => {
      throw error
    })
}
